<div class="container ">
    <mat-toolbar>
      <span>Par&aacute;metros de configuraci&oacute;n</span>
    </mat-toolbar>
    <div class="table-container">
    <table mat-table [dataSource]="dataSource" >
        <ng-container matColumnDef="codigoConfiguracion">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.codigoConfiguracion}} </td>
        </ng-container>

        <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef> Código </th>
            <td mat-cell *matCellDef="let element"> {{element.codigo}} </td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
        </ng-container>

        <ng-container matColumnDef="texto">
            <th mat-header-cell *matHeaderCellDef> Texto</th>
            <td mat-cell *matCellDef="let element">
                @if (isBase64(element.texto)) {
                <p class="element-text">
                    {{element.texto}}
                </p>
                }@else {
                <img style="max-width: 400px;" [src]="renderBase64(element.texto)" alt="miniature">
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="numero">
            <th mat-header-cell *matHeaderCellDef> Número </th>
            <td mat-cell *matCellDef="let element"> {{element.numero}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="clickedRow(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
</div>
